export default __webpack_public_path__ + "static/media/1_1-card.e749e558.png";